import React, { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import LoadingSpinner from '../common/LoadingSpinner';

const LinkPerformanceSummary = ({ onSendGeneralEmail }) => {
    const [allLinks, setAllLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('Tous'); // Tous, Défaut, Customisé

    useEffect(() => {
        const fetchLinks = async () => {
            setLoading(true);
            setError(null);
            
            const token = localStorage.getItem('authToken');
            if (!token) {
                setError("Authentification requise. Veuillez vous reconnecter.");
                setLoading(false);
                return;
            }

            try {
                const response = await fetch('https://back-desalpe.onrender.com/api/inscription/liens', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    if (response.status === 401) {
                        setError("Session expirée. Veuillez vous reconnecter.");
                    } else {
                        throw new Error('Network response was not ok');
                    }
                    return;
                }
                const data = await response.json();
                
                // Adapter les données du backend au format attendu par le frontend
                const formattedData = data.map(link => ({
                    id: link.id,
                    url: link.url_destination, // Affiche le lien de destination final
                    email: link.ambassadeur_email,
                    clicks: link.nombre_clics || 0,
                    dateAdded: new Date(link.date_creation).toLocaleDateString('fr-CA'),
                    type: link.type_lien === 'defaut' ? 'Défaut' : 'Customisé',
                    firstName: link.ambassadeur_prenom,
                    lastName: link.ambassadeur_nom,
                }));

                setAllLinks(formattedData);
            } catch (error) {
                setError('Impossible de charger le résumé des performances.');
                console.error("Failed to fetch link performance:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLinks();
    }, []);

    const filteredLinks = allLinks
        .filter(link => {
            if (filterType === 'Tous') return true;
            return link.type === filterType;
        })
        .filter(link =>
            (link.firstName && link.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (link.lastName && link.lastName.toLowerCase().includes(searchTerm.toLowerCase()))
        );

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="link-performance-summary">
            <div className="filter-bar">
                <div className="search-bar" style={{ flexGrow: 2 }}>
                    <FaSearch />
                    <input
                        type="text"
                        placeholder="Rechercher par nom ou prénom..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <span>Filtrer par type:</span>
                <button onClick={() => setFilterType('Tous')} className={filterType === 'Tous' ? 'active' : ''}>Tous</button>
                <button onClick={() => setFilterType('Défaut')} className={filterType === 'Défaut' ? 'active' : ''}>Défaut</button>
                <button onClick={() => setFilterType('Customisé')} className={filterType === 'Customisé' ? 'active' : ''}>Customisé</button>
            </div>

            <div className="links-table-container">
                <button
                    onClick={onSendGeneralEmail}
                    className="envoisgeneral"
                    style={{ marginBottom: "20px" }}
                >
                    Envoyer message général
                </button>
                <table>
                    <thead>
                        <tr>
                            <th>Prénom</th>
                            <th>Nom</th>
                            <th>Email Associé</th>
                            <th>URL du Lien</th>
                            <th>Type</th>
                            <th>Date d'ajout</th>
                            <th>Total Clics</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLinks.map((link) => (
                            <tr key={link.id}>
                                <td>{link.firstName || 'N/A'}</td>
                                <td>{link.lastName || 'N/A'}</td>
                                <td>{link.email || 'N/A'}</td>
                                <td>{link.url}</td>
                                <td>{link.type}</td>
                                <td>{link.dateAdded}</td>
                                <td>{link.clicks}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LinkPerformanceSummary;

